import banner1 from '~/assets/banner/banner-sale/b1.webp'
import banner2 from '~/assets/banner/banner-sale/b2.webp'
import banner3 from '~/assets/banner/banner-sale/b3.webp'
import banner4 from '~/assets/banner/banner-sale/b4.webp'


export const bannerListBottom = [
    banner1,
    banner2,
    banner3,
    banner4,
]